import React from 'react'
import PropTypes from 'prop-types';
import Tr from 'translations/Translations';
import Typography from "components/Typography";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import SaveDialogBase from "components/popup/save/SaveDialogBase";
import {makeStyles} from "@material-ui/core";

const useStyle = makeStyles(theme => ({
    icon: {
        color: theme.palette.common.error,
    }
}))

function AuctionSaveError(
    {
        message,
        onClose
    }) {

    const classes = useStyle();

    return (
        <SaveDialogBase
            onClose={onClose}
            title={Tr('failure')}
            Icon={HighlightOffIcon}
            iconClassName={classes.icon}
        >
            <Typography variant='body1'>
                {message}
            </Typography>
        </SaveDialogBase>
    )
}

AuctionSaveError.propTypes = {
    message: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired
}

export default AuctionSaveError;